import Vue from 'vue';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import moment from 'moment';
import { Datetime } from 'vue-datetime';
import 'vue-datetime/dist/vue-datetime.css';
import { DateTime } from "luxon";

export default {
  name: 'Manpower',
  mixins: [validationMixin],
  components: {
    datetime: Datetime,
    DateTime,
  },
  props: ['dataObj'],
  data: function () {
    return {
      manpower: {
        additionalCost: 0,
        allowance: '',
        allowanceId: 0,
        comment: '',
        dt: moment(new Date()).format(),
        employee: '',
        employeeId: 0,
        id: 0,
        isAllowance: false,
        rateHr: 0,
        rateType: '',
        rateTypeId: 0,
        totalCost: 0,
        travelDuration: 0,
        workDuration: 0
      },
      employee: {
        displayString: '',
        employeeId: 0,
        employeeName: '',
        orgPost: 0,
        orgPostName: '',
        rateHours: { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 },
        station: 0,
        stationName: '',
        teamId: -1
      },
      rateTypes: [],
      employees: [],
      employeesAll: [],
      allowances: [],
      allTeams: [],
      team: { text: '', value: '' },
      teamId: -1,
      stations: [],
      station: { text: '', value: '' },
      stationId: -1,
      selection: [],
      rateKey: 0,
      maxWorkDuration: this.dataObj.maxJobDuration
    }
  },
  validations: {
    employee: {
      required
    },
    allowance: {
      required
    },
    rateType: {
      required
    }
  },
  computed: {
    selectionCount: function () {
      return this.selection.length;
    },
    teams: function () {
      if (this.dataObj.stationId <= 0)
        return this.allTeams;
      else
        return this.allTeams.filter(t => t.group && t.group.id == this.dataObj.stationId);
    },
  },
  watch: {
    team: function (value) {
      if (!value)
        return;
      this.teamId = parseInt(value.value);
      this.filterManpowers();
    },
    station: function (value) {
      if (!value)
        return;
      this.stationId = parseInt(value.value);
      this.filterManpowers();
    },
    "manpower.rateTypeId": function (value) {
      if (!value)
        return;

      if (value < 1)
        this.manpower.rateTypeId = 1;

      this.calculateCost();
    },
    employee: function (value) {
      //console.log("employee watch", this.employee);
      if (!value)
        return;

      this.selection = [];
      this.selection.push(value);
      this.calculateCost();
    },
    selectionCount: function (value) {
      //console.log("sel", this.selection, "empl", this.employee,"jjdj", value);

      this.dataObj.selection = [];
      if (value === 0)
        return;

      this.rateKey++;
      //console.log("selection", this.selection);
      this.calculateCost(this.isMultiple);
    },
  },
  created() {
    this.init();
  },
  methods: {
    filterManpowers() {
      this.employees = this.employeesAll;
      if (this.teamId > -1)
        this.employees = this.employees.filter(p => p.teamId === this.teamId);
      if (this.stationId > -1)
        this.employees = this.employees.filter(p => p.station === this.stationId);
    },
    init() {
      console.log("manpower data in", this.dataObj);
      Vue.nextTick(() => {
        this.manpower = this.dataObj;
        this.rateTypes = this.dataObj.rateTypes;
        this.dataObj.employees.forEach(p => p.rate = 0);
        this.employees = this.dataObj.employees;
        this.employeesAll = this.dataObj.employees;
        this.allowances = this.dataObj.allowances;
        if (this.employees.filter(p => p.employeeId === this.dataObj.employeeId) && this.employees.filter(p => p.employeeId === this.dataObj.employeeId).length > 0)
          this.employee = this.employees.filter(p => p.employeeId === this.dataObj.employeeId)[0];

        this.allTeams = this.dataObj.teams;
        this.stations = this.dataObj.stations;

        this.filterManpowers();
        //console.log("data", this.dataObj);
        this.manpower.rateTypeId = this.dataObj.rateTypes[0].value;
        this.manpower.rateType = this.dataObj.rateTypes[0].text;
        //load employee
        if (this.dataObj.employeeId > 0 && this.employee != null)
          this.selection.push(this.employee);

        if (this.dataObj.stationId > 0) {
          let temp = this.stations.filter(s => s.value == this.dataObj.stationId);
          if (temp && temp.length > 0)
            this.station = temp[0];
        }
          
      });
    },

    calculateCost(multiple) {

      let total = 0;

      //error traps
      if (parseInt(this.manpower.workDuration) < 0 || isNaN(parseInt(this.manpower.workDuration))) {
        this.manpower.workDuration = 0;
        return;
      }
      if (parseInt(this.manpower.travelDuration) < 0 || isNaN(parseInt(this.manpower.travelDuration))) {
        this.manpower.travelDuration = 0;
        return;
      }
      if (this.selection == null || this.selection.length < 1)
        return;

      //calculate cost
      this.dataObj.selection = [];
      this.selection.forEach(p => {
        this.dataObj.selection.push({ id: p.employeeId, rate: p.rateHours != null ? p.rateHours[this.manpower.rateTypeId] : '', name: p.displayString });
      });

      this.dataObj.selection.forEach(p => {
        var singleCost = this.manpower.workDuration * parseFloat(p.rate) / 60 + this.manpower.travelDuration * parseFloat(p.rate) / 60;
        total = total + (p.minimumCharge > singleCost ? p.minimumCharge : singleCost);
      });

      //console.log("data selection", this.dataObj.selection);

     // console.log("MANPOWER", this.manpower);
      this.manpower.totalCost = total.toFixed(2);
    },
    setSelectedEmployee(value) {
      this.manpower.employee = this.employees.filter(p => p.employeeId === value)[0].displayString;
    },
    setSelectedAllowance(value) {
      this.manpower.allowance = this.allowances.filter(p => p.value === value)[0].text;
    },
    setSelectedRateType(value) {
      this.manpower.rateType = this.rateTypes.filter(p => p.value === value)[0].text;
    },
  },
}

